const Form044EN = {
    stepName: {
        personalInfo: "Personal Information",
        kindergarten: "Kindergarten Name",
        confirmation: "Confirmation",
        signature: "Signature",
        importantNotes: "Important Notes",
    },
    headerTitle:
        "Information on Teachers/Child Care Workers ({{schoolYear}} School Year)",
    errorMsg: {
        maxError: "Maximum length is ",
        characterType:
            "Character type (alphabets only / alpha-numeric / Chinese-only)",
        alphabetsOnly: "Character type (alphabets only)",
        chineseOnly: "Character type (Chinese-only)",
        numericOnly: " Character type (alpha-numeric)",
        otherPost: "others post",
        uploadMax: "the maximum upload file is ",
        checkPosition:
            "There must be 1 record each for Principal / Child Care Supervisor.",
        needOne:
            "must fill either 'Name of Kindergarten' or 'Name of Child Care Centre'",
        schoolHead: "Name of ",
        no: "Please fill in at least one number.",
        atLeastOneValidFirstAid:
            "At least 1 valid First Aid Certificate No. should be filled in an application",
        atLeastOneValidNo:
            "At least 1 valid No. should be filled in an application",
        repeatNo:
            "RT No. and valid PT No. should not be filled at the same time in a staff record",
    },
    schoolHeadOption: {
        supervisor: "Supervisor",
        principal: "Principal",
    },
    title5: "Personal Information Collection Statement",
    label: {
        statement:
            "I have read, understand and agree to the above terms and conditions.",
        iamSmartStatement:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        kindergarten: "Name of Kindergarten",
        childCareCentre: "Name of Child Care Centre",
        basicInfor: "Kindergarten and Child Care Centre Name",
        note: {
            noteTitle: "Notes：",
            note1: "「BEd(ECE)」：QKTs/CCWs with a bachelor degree in Early Childhood Education or equivalent",
            note2: "「C(ECE)」：QKTs/CCWs with a Certificate in Early Childhood Education or equivalent",
            note3: "「QKT」：Qualified Kindergarten Teachers",
            note4: "「CCW」：Child Care Workers",
            note5: "「Pursuing C(ECE)」：QKTs/CCWs or teaching staff with RT/valid PT No. pursuing a Certificate in Early Childhood Education or equivalent",
            note6: " Please tick the appropriate column",
            note7: "Unless already submitted, please send in all the certified true copies of registration certificates and valid first aid certificates of teacher / child care staff for record",
            note8: "1 record each for Principal and Child Care Supervisor, or Other post (please specify)  must be included in an application",
            note9: "A Principal and a Child Care Supervisor, or Other post (please specify) must be included in an application",
        },
        personalInfo: {
            teacherNameEn: "Name of Teacher/Child Care Worker (English)",
            teacherNameCh: "Name of Teacher/Child Care Worker (Chinese)",
            qualification: "Qualification",
            rtptLabel: "RT No./valid PT No.",
            // rtptOption: { rtNo: "RT No.", validPTNo: "Valid PT No." },
            rtNo: "RT No.",
            validPTNo: "Valid PT No.",
            cccLabel: "CCC/S No./CCC/W No.",
            // cccOption: {
            //     cccsNo: "CCC/S No.",
            //     cccwNo: "CCC/W No.",
            // },
            cccsNo: "CCC/S No.",
            cccwNo: "CCC/W No.",
            workingHours: "Working Hours",
            appointment: "1st Day of Appointment in this KG-cum-CCC",
            post: "Post",
            otherPost: "Please specify",
            classResponsible: "Class Responsible for",
            firstAid: "First Aid Training Received",
            certificateNo: "Valid First Aid Certificate No.(if any)",
            certificateNoErrField: "Valid First Aid Certificate No.",
            aidCertificateNoValid: "First Aid Certificate No. valid on",
            aidCertificateNoExpiry: "First Aid Certificate No. expiry on",
            aidCertificateAttachment: "First Aid Certificate Attachment",

            signatureTitle: "Signing Information",
            schoolHead: "Supervisor / Principal",
            schoolHeadName: "Name of ",
            upload: {
                uploadButton:
                    "Unless already submitted, please attach all the certified true copies of registration certificates and valid first aid certificates of teacher / child care staff for record",
                // remark: {
                //     title: "remark:",
                //     content: "The maximum size of each file is 10MB",
                //     content2:
                //         "Acceptable file types: pdf, jpg, jpeg，png, zip, rar",
                //     content3: "Maximum number of files: 1",
                // },
            },
            qualificationGP: {
                bed: "BEd(ECE)",
                c: "C(ECE)",
                qkt: "QKT",
                ccw: "CCW",
                pursuing: "Pursuing C(ECE)",
            },
            workingTime: {
                ap: "AM + PM",
                am: "AM",
                pm: "PM",
            },
            postGP: {
                principal: "Principal",
                childCare: "Child Care Supervisor",
                other: "Others, please specify (e.g. Teacher, Senior Teacher, Child Care Worker, Vice Principal etc.):",
            },
            classGP: {
                kg: "KG",
                ccc: "CCC",
            },
            firstAidGP: {
                yes: "Yes",
                no: "No",
            },
        },
    },
    title: {
        title1: "Personal Information Collection Statement",
    },
    note: {
        note1: {
            title: `1.	The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:`,
            subtitle: "Purpose of Collection",
            content1:
                "(a)	Activities relating to the processing, authentication and counter-checking of the Information on Teachers / Child Care Workers;",
            content2:
                "(b)	Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            content3:
                "(c)	Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            content4:
                "(d)	Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            content5:
                "(e)	Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            content6:
                "(f)	Activities relating to compilation of statistics, research and Government publications; and",
            content7:
                "(g)	Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) ) ",
        },
        note2: {
            title: `2.	The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.`,
        },
        note3: {
            title: `3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-`,
            subtitle: "Classes of Transferees",
            content1:
                "(a)	other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
            content2:
                "(b)	the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            content3:
                "(c)	where you have given your prescribed consent to such disclosure; and",
            content4:
                "(d)	where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `4.	You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.`,
            subtitle: "Access to Personal Data",
        },
    },
};
export default Form044EN;
